/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Fragment from 'ember-data-model-fragments/fragment';
import { attr } from '@ember-data/model';

export default class CollectionsPageOptions extends Fragment {
  @attr('boolean', { defaultValue: false }) declare showArticleDescriptions: boolean;
}
